import { motion } from "framer-motion";

const Achievements = () => {
  const achievements = [
    "Quarterly Excellence Award for outstanding work with LLMs at Deutsche Bank (2023).",
    "Passed Deutsche Bank Cloud Engineering Program with distinction (2024).",
    "Dipak Sengupta Memorial Award for excellence in academics and extracurriculars (2019).",
  ];

  return (
    // <section id="achievements" className="h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
    <section id="achievements" className="md:h-screen min-h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
      <div className="container mx-auto px-8 text-center">
        
        {/* Animated Heading (Matches Projects) */}
        <motion.h2
          className="text-5xl font-extrabold text-gray-900 relative inline-block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Achievements
          <span className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-600 to-purple-500 rounded-lg"></span>
        </motion.h2>

        {/* Achievements List */}
        <motion.div 
          className="mt-12 max-w-3xl mx-auto space-y-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {achievements.map((achievement, index) => (
            <motion.div
              key={index}
              className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 transition-transform hover:scale-105 flex items-center"
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <span className="text-blue-600 text-2xl mr-4">✔</span>
              <p className="text-lg text-gray-800">{achievement}</p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Achievements;
